import React, { useState, useEffect } from 'react';
import { adminFetch } from '../../lib/adminFetch';

const ACTION_COLORS = {
  '顧客登録': 'bg-emerald-100 text-emerald-700',
  '顧客編集': 'bg-blue-100 text-blue-700',
  '顧客削除': 'bg-red-100 text-red-600',
  'メール返信': 'bg-indigo-100 text-indigo-700',
  'ML一斉送信': 'bg-purple-100 text-purple-700',
  '管理者追加': 'bg-emerald-100 text-emerald-700',
  '管理者削除': 'bg-red-100 text-red-600',
  '権限変更': 'bg-amber-100 text-amber-700',
  '動画視聴': 'bg-teal-100 text-teal-700',
  '動画再生開始': 'bg-teal-100 text-teal-700',
  '動画視聴完了': 'bg-cyan-100 text-cyan-700',
};

const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
  } catch { return iso; }
};

const AuditLogAdmin = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => {
    setLoading(true);
    setError('');
    adminFetch('/api/admin-audit.php?action=list&limit=300&t=' + Date.now())
      .then((r) => r.json())
      .then((d) => {
        if (d.success) setLogs(d.logs || []);
        else setError(d.message || '取得に失敗しました');
      })
      .catch(() => setError('取得に失敗しました'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold">監査ログ</h2>
          <p className="text-xs text-gray-500 mt-1">誰が・いつ・何をしたか（顧客登録・メール返信・ML送信・管理者権限変更など）の記録です。新しい順に表示しています。</p>
        </div>
        <button onClick={load} className="bg-pink-dark text-white px-4 py-2 rounded-lg text-sm font-bold hover:bg-brown">更新</button>
      </div>

      {error && <div className="mb-4 px-4 py-2 bg-red-100 text-red-800 rounded-lg text-sm">{error}</div>}

      <div className="bg-white rounded-xl shadow overflow-hidden">
        {loading ? (
          <div className="p-8 text-center text-gray-400">読み込み中...</div>
        ) : logs.length === 0 ? (
          <div className="p-8 text-center text-gray-400">記録がありません</div>
        ) : (
          <div className="divide-y divide-gray-100">
            {logs.map((log, i) => (
              <div key={i} className="flex items-start gap-3 px-5 py-3">
                <span className="text-xs text-gray-400 shrink-0 w-36 pt-0.5 tabular-nums">{formatDate(log.date)}</span>
                <span className="text-sm font-bold shrink-0 w-24 truncate">{log.name || log.email}</span>
                <span className={`text-[11px] font-bold px-2 py-0.5 rounded shrink-0 ${ACTION_COLORS[log.action] || 'bg-gray-100 text-gray-600'}`}>
                  {log.action}
                </span>
                <span className="text-sm text-gray-700 flex-1 break-all">{log.detail}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AuditLogAdmin;
